import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { requestAutobooking } from 'shared/actions/advertForm';
import { bindActionCreators } from 'redux';
import withStatsEvents from 'shared/hocs/stats/withStatsEvents';
import { connect } from 'react-redux';
import Iframe from 'react-iframe';
import { enqueueNotification } from 'shared/actions/notifications';
import withOrders from 'shared/hocs/withOrders';

const isMobile = __APP__ === 'mobile';

class AutobookingForm extends React.Component {
  static propTypes = {
    className: PropTypes.oneOfType([PropTypes.string]),
    enqueueNotification: PropTypes.func.isRequired,
    events: PropTypes.shape().isRequired,
    globals: PropTypes.shape(),
    intl: intlShape.isRequired,
    action: PropTypes.shape({ requestAutobooking: PropTypes.func }),
    advert: PropTypes.shape().isRequired,
  };
  static defaultProps = {
    className: '',
    user: {},
    action: {},
    advert: {},
    globals: {},
    loading: false,
    minCustomReasonLength: 4,
    isUpdating: false,
    isRemoval: false,
  };

  state = {
    onModal: false,
    anotherReasonText: '',
  };

  signUpStoStats = () => {
    const {
      events,
      advert: { id },
    } = this.props;
    events.dispatchDealerSignUp(id);
  };

  handleChange(key, data) {
    const {
      advert: { autobooking_id: autobookingId },
      intl,
    } = this.props;
    const fun = {
      onModal: dat => {
        this.setState({ onModal: dat });
      },
      testAutobooking: () => {
        this.signUpStoStats();
        this.props.action.requestAutobooking(
          {
            callback: () => {
              this.setState({ onModal: true });
            },
            autobookingId,
          },
          {
            enqueueNotification: this.props.enqueueNotification,
            intl,
          },
        );
      },
    };
    if (fun[key]) {
      fun[key](data);
    } else {
      console.error(key);
    }
  }

  handleSignUpToSto = e => {
    e.preventDefault();
    this.handleChange('testAutobooking');
  };

  render() {
    const {
      advert: { autobooking_id: autobookingId },
      className,
      globals: { locale },
    } = this.props;
    if (!autobookingId) {
      return '';
    }
    return (
      <div>
        AutobookingForm 112
        <ModalContainer
          onClose={() => {
            this.handleChange('onModal', false);
          }}
          isOpen={this.state.onModal}
          modalCN={' '}
        >
          <div
            style={{
              height: isMobile ? '500px' : '400px',
              width: isMobile ? '420px' : '500px',
            }}
          >
            <Iframe
              height={isMobile ? '500px' : '400px'}
              width={isMobile ? '420px' : '500px'}
              url={`https://autobooking.com/widgets/order?autocomplete_brand=true&autocomplete_location=true&autocomplete_service=true&height=500px&locale_country=${
                locale === 'ru' ? locale : 'ua'
              }-ua&mobile_height=460px&mobile_width=400px&referer_key=DOQLoCkKnLITeqQ5a0dmog&station_id=${autobookingId}&view=intable&width=200px`}
            />
          </div>
        </ModalContainer>
        <div className={className} onClick={this.handleSignUpToSto}>
          <FormattedMessage id="Записаться на СТО" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ globals, user: { user }, loading }) => ({
  globals,
  user,
  enqueueNotification,
  loading: Boolean(loading.start),
});

const mapDispatchToProps = dispatch => ({
  action: bindActionCreators({ requestAutobooking }, dispatch),
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withOrders(withStatsEvents(injectIntl(AutobookingForm))));



// WEBPACK FOOTER //
// ./src/shared/components/AutobookingForm/AutobookingForm.js